import React from 'react'

const Error = () => {
  return (
    <div className='text-4xl font-semibold flex items-center justify-center'>
      Error - 404 Page Not Found
    
    </div>
  )
}

export default Error